import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

export default function BulkUploadButton({ onClick }) {
  return (
    <Button
      size="small"
      type="default"
      icon={<UploadOutlined />}
      onClick={onClick}
      style={{
        borderRadius: "4px",
        padding: "0 12px",
        height: "auto",
      }}
    >
      Bulk Upload
    </Button>
  );
}
